import React from 'react';
import { useQuery } from '@apollo/client';
import { toGlobalId } from 'graphql-relay';
import { RouteComponentProps } from 'react-router';

import LoadingProgress from 'lib/react-router/loading-progress';
import ScrollToTop from 'lib/scroll/scroll-to-top';

import ErrorPage from 'four-nets/errors/error-page';

import Image from './image';
import query, { ImageLoaderQuery, ImageLoaderQueryVariables } from './image-loader.graphql';

interface Params {
    imageId: string;
}

const ImageLoader: React.FC<RouteComponentProps<Params>> = props => {

    const imageId = toGlobalId('ImageNode', props.match.params.imageId);
    const commentId = props.location.hash.startsWith('#comment-')
        ? toGlobalId('CommentNode', props.location.hash.split('-')[1])
        : undefined;

    const { data, loading, error } = useQuery<ImageLoaderQuery, ImageLoaderQueryVariables>(query, {
        errorPolicy: 'all',
        variables: { id: imageId },
    });

    let errorWithCode = null;
    if (error) {
        const gqlError = error?.graphQLErrors[0];
        if (gqlError?.extensions?.code == 401) {
            errorWithCode = { ...error, code: 401 };
        } else if (gqlError?.extensions?.code == 404) {
            errorWithCode = { ...error, code: 404 };
        } else {
            errorWithCode = { ...error, code: 500 };
        }
    } else if (!loading && (!data || !data.image)) {
        errorWithCode = { ...new Error(), code: 404 };
    }

    return (
        <>
            <ScrollToTop imageId={imageId} />
            <LoadingProgress loading={loading}>
                <ErrorPage error={errorWithCode}>
                    {data?.image ? (
                        <Image image={data.image} commentId={commentId} />
                    ) : null}
                </ErrorPage>
            </LoadingProgress>
        </>
    );
};

export default ImageLoader;
